export const CommonOperationTaxes = {} as const
